//Created by wangshuyi on 07/03/2018.

'use strict';
import core from 'dolphin-framework-vue/core/Dol-core'
import API from '@/components/common/apiConfig';
import { message } from 'ant-design-vue';
import * as AntIcons from '@ant-design/icons-vue';
import store from '@/store/index';

const panda = {
  name: 'dol-icon-panda',
  template: `<svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
      <path d="M99.096 315.634s-82.58-64.032-82.58-132.13c0-66.064 33.032-165.162 148.646-148.646 83.37 11.91 99.096 165.162 99.096 165.162l-165.162 115.614zM924.906 315.634s82.58-64.032 82.58-132.13c0-66.064-33.032-165.162-148.646-148.646-83.37 11.91-99.096 165.162-99.096 165.162l165.162 115.614z" fill="#6B676E" p-id="1143" />
      <path d="M1024 561.548c0 264.526-229.23 429.42-512.002 429.42S0 826.076 0 561.548 283.96 66.064 512.002 66.064 1024 297.022 1024 561.548z" fill="#FFEBD2" p-id="1144" />
      <path d="M330.324 842.126c0 82.096 81.34 148.646 181.678 148.646s181.678-66.55 181.678-148.646H330.324z" fill="#E9D7C3" p-id="1145" />
      <path d="M644.13 611.098C594.582 528.516 561.55 512 512.002 512c-49.548 0-82.58 16.516-132.13 99.096-42.488 70.814-78.73 211.264-49.548 247.742 66.064 82.58 165.162 33.032 181.678 33.032 16.516 0 115.614 49.548 181.678-33.032 29.18-36.476-7.064-176.93-49.55-247.74z" fill="#FFFFFF" p-id="1146" />
      <path d="M611.098 495.484c0-45.608 36.974-82.58 82.58-82.58 49.548 0 198.194 99.098 198.194 165.162s-79.934 144.904-148.646 99.096c-49.548-33.032-132.128-148.646-132.128-181.678zM412.904 495.484c0-45.608-36.974-82.58-82.58-82.58-49.548 0-198.194 99.098-198.194 165.162s79.934 144.904 148.646 99.096c49.548-33.032 132.128-148.646 132.128-181.678z" fill="#6B676E" p-id="1147" />
      <path d="M512.002 726.622c-30.06 0-115.614 5.668-115.614 33.032 0 49.638 105.484 85.24 115.614 82.58 10.128 2.66 115.614-32.944 115.614-82.58-0.002-27.366-85.556-33.032-115.614-33.032z" fill="#464655" p-id="1148" />
      <path d="M330.324 495.484m-33.032 0a33.032 33.032 0 1 0 66.064 0 33.032 33.032 0 1 0-66.064 0Z" fill="#464655" p-id="1149" />
      <path d="M693.678 495.484m-33.032 0a33.032 33.032 0 1 0 66.064 0 33.032 33.032 0 1 0-66.064 0Z" fill="#464655" p-id="1150" />
    </svg>`
};
const right = {
  name: 'dol-icon-right',
  template: `<svg width="1em" height="1em" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="01-首页" transform="translate(-163.000000, -381.000000)" fill-rule="nonzero">
            <g id="箭头" transform="translate(187.000000, 405.000000) rotate(90.000000) translate(-187.000000, -405.000000) translate(163.000000, 381.000000)">
                <path stroke="currentColor" fill="currentColor" d="M33.6,19.2 C33.8916725,19.4885208 34.0558,19.8817353 34.0558,20.292 C34.0558,20.7022647 33.8916725,21.0954792 33.6,21.384 C33.3269959,21.6858597 32.9390018,21.8580932 32.532,21.8580932 C32.1249982,21.8580932 31.7370041,21.6858597 31.464,21.384 L25.992,15.984 L25.992,35.776 C26.0662026,36.3661368 25.7930324,36.9460685 25.2907783,37.264672 C24.7885241,37.5832755 24.1474759,37.5832755 23.6452217,37.264672 C23.1429676,36.9460685 22.8697974,36.3661368 22.944,35.776 L22.944,15.984 L17.472,21.6 C16.7669415,21.965873 15.9069497,21.8402562 15.336,21.288 C15.0443275,20.9994792 14.8802,20.6062647 14.8802,20.196 C14.8802,19.7857353 15.0443275,19.3925208 15.336,19.104 L22.968,11.304 C23.2765033,10.8517707 23.7885645,10.5812267 24.336,10.5812267 C24.8834355,10.5812267 25.3954967,10.8517707 25.704,11.304 L33.6,19.2 Z" id="路径"></path>
            </g>
        </g>
    </g>
</svg>`
};

export default {
  install(app){
    app.config.globalProperties.$api = core.formatApi(API);
    app.component(core.camelToKebab(panda.name), panda);
    app.component(core.camelToKebab(right.name), right);
    Object.keys(AntIcons).forEach(key => /(Filled|Outlined|TwoTone)$/.test(key) && app.component('dol-icon-' + core.camelToKebab(key), AntIcons[key]));

    core({
      iconMap: { panda, right, ...AntIcons },
      ajax: {
        loginPath: `${core.path.contextPath}/login`,
        alertMessage: _message => message.error(_message),
      }
    });

    core.prompt = ({title, type = 'input', onOk, onCancel, defaultValue = ''}) => {
      store.state.app.prompt.title = title;
      store.state.app.prompt.value = defaultValue;
      store.state.app.prompt.type = type;
      store.state.app.prompt.onOk = onOk;
      store.state.app.prompt.onCancel = onCancel;
      store.state.app.prompt.visible = true;
    }
  }
};
